<template>
  <div></div>
</template>

<script>
export default {
  name: "FormMixin",
  data() {
    return {
      services: {
        display: [
          {
            name: "Google",
            slug: "google_display",
          },
          {
            name: "Google Remarketing",
            slug: "google_display_remarketing",
          },
          {
            name: "Facebook",
            slug: "facebook_display",
          },
          {
            name: "Facebook Remarketing",
            slug: "facebook_display_remarketing",
          },
          {
            name: "Simplifi",
            slug: "simplifi_display",
          },
        ],
        video: [
          {
            name: "Google",
            slug: "google_video",
          },
          {
            name: "Google Remarketing",
            slug: "google_video_remarketing",
          },
          {
            name: "Facebook",
            slug: "facebook_video",
          },
          {
            name: "Facebook Remarketing",
            slug: "facebook_video_remarketing",
          },
          {
            name: "Simplifi",
            slug: "simplifi_tv",
          },
          {
            name: "Tremor",
            slug: "tremor_tv",
          },
        ],
        sem: [
          {
            name: "Google",
            slug: "google_sem",
          },
          {
            name: "Bing",
            slug: "bing_sem",
          },
        ],
      },
      defaults: {
        display: {
          selected: false,
          budget: 0,
          type: "cpm",
          percent: 0,
          cpm: 0,
          budgets: {
            google_display: 0,
            google_display_remarketing: 0,
            facebook_display: 0,
            facebook_display_remarketing: 0,
            simplifi_display: 0,
          },
          services: [],
        },
        video: {
          selected: false,
          budget: 0,
          type: "cpm",
          percent: 0,
          cpm: 0,
          budgets: {
            google_video: 0,
            google_video_remarketing: 0,
            facebook_video: 0,
            facebook_video_remarketing: 0,
            simplifi_tv: 0,
            tremor_tv: 0,
          },
          services: [],
        },
        sem: {
          selected: false,
          budget: 0,
          percent: 0,
          budgets: { google_sem: 0, bing_sem: 0 },
          services: [],
        },
      },
    }
  },
}
</script>

<style lang="scss" scoped>
</style>
